export const DEPLOYMENT_DURATION = 13400;
export const DEPLOYMENT_STOPS = [0, 4000, 10000, DEPLOYMENT_DURATION];

export function deploymentStage(time) {
  if (time >= 10200) return 3;
  if (time >= 4200) return 2;
  if (time >= 1600) return 1;
  return 0;
}

export function smoothProgress(time, start, duration) {
  const progress = Math.min(1, Math.max(0, (time - start) / duration));
  return progress * progress * (3 - 2 * progress);
}

// Cache the scene once. Frames only write transforms, opacity and SVG strokes;
// they never measure layout or render the React tree.
export function createDeploymentScene(root) {
  const canvas = root.querySelector(".deployment-canvas");
  const logo = root.querySelector(".deployment-logo");
  const progress = root.querySelector(".deployment-progress span");
  const flow = root.querySelector(".deployment-flow");
  const reveals = [
    [".deployment-core > span", 700, 1200, 4],
    [".deployment-data-theirs", 1900, 1200, 7],
    [".deployment-data-ours", 2400, 1200, 7],
    [".deployment-scientist", 3400, 1300, 6],
    [".deployment-agents", 4400, 1300, 8],
    [".deployment-agent-roles span:nth-child(1)", 4850, 850, 3],
    [".deployment-agent-roles span:nth-child(2)", 5100, 850, 3],
    [".deployment-agent-roles span:nth-child(3)", 5350, 850, 3],
    [".deployment-approval", 5850, 1000, 3],
    [".deployment-lab > div:first-child", 7000, 1200, 6],
    [".deployment-lab > div:last-child", 7500, 1200, 6],
    [".deployment-feedback", 8800, 1200, 4],
    [".deployment-asset", 10800, 1500, 8],
  ].map(([selector, start, duration, distance]) => ({ element: root.querySelector(selector), start, duration, distance }));
  const wires = [
    ["data-private", 1450, 1350],
    ["data-cornucopia", 2000, 1350],
    ["core-agents", 3500, 1400],
    ["question", 4200, 1100],
    ["lab-trunk", 6200, 1050],
    ["lab-handler", 6750, 1050],
    ["lab-instruments", 7100, 1050],
    ["results", 8000, 1800],
    ["asset", 10100, 1200],
  ].map(([name, start, duration]) => ({ element: root.querySelector(`[data-wire="${name}"]`), start, duration }));

  return {
    canvas,
    render(time, still = false) {
      const landing = smoothProgress(time, 0, 2100);
      logo.style.transform = `translate3d(0, ${-72 * (1 - landing)}px, 0) scale(${1 + 0.07 * (1 - landing)})`;
      reveals.forEach(({ element, start, duration, distance }) => {
        const amount = smoothProgress(time, start, duration);
        element.style.opacity = amount;
        element.style.transform = `translate3d(0, ${(1 - amount) * distance}px, 0)`;
      });
      wires.forEach(({ element, start, duration }) => {
        const amount = smoothProgress(time, start, duration);
        element.style.opacity = Math.min(1, amount * 4);
        element.style.strokeDashoffset = 1 - amount;
      });
      flow.style.opacity = still ? 0 : smoothProgress(time, 9000, 1300) * 0.6;
      flow.style.strokeDashoffset = -Math.max(0, time - 9000) / 42;
      if (progress) progress.style.transform = `scaleX(${time / DEPLOYMENT_DURATION})`;
    },
  };
}
